<template>
  <div id="getStarted">
    <main class="get-started">
      <div class="row">
        <h1>{{ getTranslations.visitor_index_get_started_msg_1 }}
          <br><strong>{{ getTranslations.visitor_index_get_started_msg_2 }}</strong></h1>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="tablet"></div>
        </div>
        <div class="col-lg-6">
          <div class="row">
            <div class="prize-img">
              <img :src="getTranslations.project_config_visitor_index_get_started_prizes_img" :alt="getTranslations.project_config_index_duel_prizes">
            </div>
          </div>
          <div class="row">
            <div class="button">
              <a @click.prevent="goToRegistration"
                 style="cursor: pointer"
                 class="btn btn--large btn--main">
                {{ getTranslations.visitor_index_get_started }}
              </a>
            </div>
          </div>
          <p class="get_started_disclaimer">{{ getTranslations.visitor_get_started_disclaimer }}</p>
        </div>
      </div>
      <img :class="['get-started__free_trial ', freeTrialStripe ? '' : 'free_off']" :src="getTranslations.project_config_visitor_index_get_started_prizes_free_trial_img" alt="">
    </main>

    <!-- MOBILE VIEW STARTS HERE -->
    <main class="get-started-mobile">
      <div class="row">
        <div class="col-md-12 tablet"><img src="static/images/safari_uc.png" alt=""></div>
        <div class="col-md-12 button">
          <a @click.prevent="goToRegistration"
             style="cursor: pointer"
             class="btn btn--large btn--main">
            {{ getTranslations.visitor_index_get_started }}
          </a>
          <p class="get_started_disclaimer">{{ getTranslations.visitor_get_started_disclaimer }}</p>
        </div>
        <div class="col-md-12 title">
          <h1>{{ getTranslations.visitor_index_get_started_msg_1 }}
            <br><strong>{{ getTranslations.visitor_index_get_started_msg_2 }}</strong></h1>
        </div>
        <div class="col-md-12 prize-img"><img :src="getTranslations.project_config_visitor_index_get_started_prizes_img" :alt="getTranslations.project_config_index_duel_prizes"></div>
      </div>
      <img :class="['get-started__free_trial ', freeTrialStripe ? '' : 'free_off']" :src="getTranslations.project_config_visitor_index_get_started_prizes_free_trial_img" alt="">
    </main>
    <simplify-registration v-if="showSimpleRegistrationModal"
                           @close="showSimpleRegistrationModal = false;">
    </simplify-registration>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import RegistrationFlowMixin from '@/common/mixins/flow';
import simplifyRegistration from '@/components/home/modals/flow/SimplifyRegistration';

export default {
  name: 'index',
  mixins: [RegistrationFlowMixin],
  components: { simplifyRegistration },
  data() {
    return {
      showSimpleRegistrationModal: false,
    };
  },
  created() {
    const totalEarnedPoints = this.$route.query.totalEarnedPoints;
    const freeGamePrizeData = this.$route.query.freeGamePrize;
    if (totalEarnedPoints) {
      this.storeRegistrationPoints({
        totalPoints: totalEarnedPoints,
      });
    } else if (freeGamePrizeData) {
      this.storeAvailableFreePlayPrize(this.getLocale);
      this.storeRegistrationPoints({
        freeGamePrize: freeGamePrizeData,
      });
    }
    //  HE flow for TPAY
    if (this.getIntegrationConfig.integrationKey === this.availableIntegrations.TPAY_EGYPT) {
      const locale = this.getLocale;
      let lang;
      if (locale === 'EN') {
        lang = 'en';
      } else {
        lang = locale === 'AR' ? 'ar' : 'fr';
      }
      this.$axios.get(`publicapi/loadTpayScript?lang=${lang}`).then((params) => {
        /* eslint-disable */
        let date = params.data.data.date;
        let digest = params.data.data.digest;
        sessionStorage.setItem("redirectUrl", params.data.data.redirectUrl);
        sessionStorage.setItem("can", params.data.data.customerAccountNumber);


        const url = `https://enrichment.tpay.me/idxml.ashx/v2/js?date=${date}&lang=${lang}&digest=${digest}`;

        $.get(url, function (script) {

          console.log(script);
          const scriptToAdd = document.createElement('script'); // Create <script>
          scriptToAdd.type = 'text/javascript';
          scriptToAdd.id = 'tpay_evina_script';
          const code = document.createTextNode(script); // Attach TPay JS script to <script>
          scriptToAdd.appendChild(code);
          document.head.appendChild(scriptToAdd);

          const tag = document.createElement('script');
          tag.type = 'text/javascript';
          tag.id = 'tpay_evina_exe';

          let inlineScript = document.createTextNode("var event = new Event('Call');\n" +
            "const tpay = document.getElementById('tpay_evina_script');\n" +
            "      if (tpay) {\n" +
            "          const enriched = TPay.HeaderEnrichment.enriched();\n" +
            "          console.log(enriched);\n" +
            "          if (enriched) {\n" +
            "             TPay.HeaderEnrichment.hasSubscription(\"sub_product\", \n" +
            "                 async function (result, subId) {\n" +
            "                    if (result) { \n" +
            "                       if (subId) { \n" +
            "                         console.log('subId = ', subId);\n" +
            "                         sessionStorage.setItem(\"subId\", subId);\n" +
            "                         let url = window.location.href; \n" +
            "                         (url.indexOf('?') > -1) ? url += '&' : url += '?' \n" +
            "                         url += 'hasSub=true'; \n" +
            "                         console.log('Redirecting to ', url); \n" +
            "                         window.location.href = url; \n" +
            "                         const btn = document.getElementById('submitBtn');\n" +
            "                         btn.removeAttribute('disabled');\n" +
            "                       } else { \n" +
            "                         console.log('subId is not set. continuing to current page '); \n" +
            "                         const btn = document.getElementById('submitBtn');\n" +
            "                         btn.removeAttribute('disabled');\n" +
            "                       } \n" +
            "                     } else { \n" +
            "                       const btn = document.getElementById('btn');\n" +
            "                       btn.removeAttribute('disabled');\n" +
            "                       console.log('result is: ' + result + ' continuing to current page'); \n" +
            "                     } \n" +
            "                 } \n" +
            "              );\n" +
            "          }\n" +
            "      } else {\n" +
            "          console.log(\"Error loading TPay script\");\n" +
            "      }\n");
          tag.appendChild(inlineScript);
          inlineScript = document.createTextNode('document.dispatchEvent(event);');
          tag.appendChild(inlineScript);
          document.head.appendChild(tag);
        });
      });
      /* eslint-enable */
    }
  },
  methods: {
    ...mapMutations('common', [
      'setInstallPromptEvent',
    ]),
    ...mapMutations('game', [
      'storeRegistrationPoints',
    ]),
    ...mapActions('profile', [
      'storeAvailableFreePlayPrize',
    ]),
    goToRegistration() {
      if(this.isRegistrationViaSms) {
        this.$router.push({ name: 'registerViaSMS' });
        return;
      }
      /* eslint-disable */
      if (this.getIntegrationConfig.integrationKey === this.availableIntegrations.TPAY_EGYPT) {
        if (!TPay.HeaderEnrichment.enriched()) {
          const msisdn = TPay.HeaderEnrichment.msisdn();
          const operatorCode = TPay.HeaderEnrichment.operatorCode();
          sessionStorage.setItem('msisdn', msisdn);
          sessionStorage.setItem('operatorCode', operatorCode);
          if (sessionStorage.getItem('hasTpaySub') === true || sessionStorage.getItem('hasTpaySub') === 'true') {
            this.$axios.get(`/api/tpayAutologin?msisdn=${msisdn}&opCode=${operatorCode}`).then((response) => {
              console.log(response);
            });
          } else {
            const obj = {
              msisdn: msisdn,
              subscriptionPlanId: '1519',
              productCatalog: 'catalog',
              productSku: 'sub_product',
              operatorCode: operatorCode,
              customerAccountNumber: sessionStorage.getItem('can'),
              redirectURL: sessionStorage.getItem("redirectUrl"),
            };
            console.log('Confirm return obj = ', obj);

            try {
              TPay.HeaderEnrichment.confirm(obj,
                async function (status, refCode, contract) {
                  console.log('status: ' + status + ' refcode: ' + refCode + ' contract: ' + contract);
                  if (status === true) { // No error or fail case
                    if (contract) { // Redirection Flow
                      return contract;
                    }
                    if (refCode) { // HE Flow
                      const msisdnHE = sessionStorage.setItem('msisdn', TPay.HeaderEnrichment.msisdn());
                      const opCodeHE = sessionStorage.setItem('operatorCode', TPay.HeaderEnrichment.operatorCode());
                      const sessionToken = await TPay.HeaderEnrichment.sessionToken();
                      sessionStorage.setItem('sessionToken', sessionToken);
                      console.log('Got msisdnHE: ', msisdnHE, ' opCodeHE: ', opCodeHE, ' sessionToken: ', sessionToken);
                      this.$axios.get(`/api/addContractRequest?msisdn=${msisdnHE}&operator=${opCodeHE}&lang=${this.getLocale}`).then((res) => {
                        console.log(res);
                      });
                    }
                    // For Wifi flow, proceeds to Register1 w/ Operator Selection Modal
                  }
                }
              );

            } catch (error) {
              console.error(error);
            }
          }
        }
      }
      if (!this.hasWebRegister()) {
        this.showSimpleRegistrationModal = true;
      } else {
        this.registrationAction();
      }
      /* eslint-disable */

    }
  },
  computed: {
    ...mapState('common', [
      'freeTrialStripe',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
    ...mapGetters('common', [
      'isRegistrationViaSms',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/Index.vue